import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Permission } from '@coin/shared/core/util-models';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root'
})
export class ChildRouteRedirectorGuard {
  private readonly router = inject(Router);
  private readonly permissionsService = inject(PermissionsService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const firstChild = route.routeConfig.children.find(
      child =>
        (!child.redirectTo && !child.data?.allowedResources) ||
        this.permissionsService.isSuperAdmin() ||
        this.permissionsService.hasPermissions(
          ...((child.data?.allowedResources ?? []) as Permission[]).map(({ resource }) => resource)
        )
    );

    if (!firstChild) {
      return false;
    }

    // TODO: For now this only works at the first nesting-level (e.g. /user-mgmt/users)
    if (state.url.split('/').filter(s => !!s).length > 1) {
      return true;
    }

    return this.router.parseUrl(`${state.url}/${firstChild.path}`);
  }
}
